import React from 'react';
import { lifecycle } from 'recompose';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { MenuContainer, MenuSections, MenuPrimarySection, MenuFooter, MenuFooterButton, Spacer } from './components';
import { NavItem, DynamicAssetsKeys } from 'packages/smart-home-support/assets/models';
import getPartnerAsset from 'packages/smart-home-support/assets';
import { ctaProps } from 'packages/smart-home-support/constants';
import { prepareNavItems } from 'packages/smart-home-support/utils';
import { MaybeUser } from 'packages/smart-home-support/pages/auth/models';
import { usePartner, PartnerContent } from 'packages/smart-home-support/partner';

type MenuProps = {
  isOpen: boolean;
  onClose: Function;
  hasSignupButton: boolean;
  path: string;
  isAuthEnabled: boolean;
  user: MaybeUser;
};

const menuSectionsHtmlId = 'menuSections';
const menuSectionsRef = React.createRef<any>();
const menuItems: NavItem[] = getPartnerAsset(DynamicAssetsKeys.headerNavLinks);
const loggedInMenuItems: NavItem[] = getPartnerAsset(DynamicAssetsKeys.loggedInHeaderNavLinks);
const homeCallToAction = getPartnerAsset(DynamicAssetsKeys.homeCallToAction);

const Menu: React.SFC<MenuProps> = (props) => {
  const [{ claimUrl }] = usePartner();

  const items = prepareNavItems(props.isAuthEnabled && props.user ? loggedInMenuItems : menuItems, {
    vars: { claimUrl: claimUrl || '' },
    isAuthEnabled: props.isAuthEnabled,
  });

  return (
    <MenuContainer isMenuOpen={props.isOpen}>
      <MenuSections id={menuSectionsHtmlId} ref={menuSectionsRef}>
        <MenuPrimarySection items={items} isOpen={props.isOpen} onClose={props.onClose} path={props.path} />
      </MenuSections>
      {props.user ? (
        <Spacer />
      ) : (
        <PartnerContent TechCoachHome="" Verizon="">
          <MenuFooter isMenuOpen={props.isOpen}>
            {props.hasSignupButton && (
              <MenuFooterButton id="header-menu-sign-up-button" onClick={props.onClose as any} {...ctaProps}>
                {homeCallToAction}
              </MenuFooterButton>
            )}
          </MenuFooter>
        </PartnerContent>
      )}
    </MenuContainer>
  );
};

export default lifecycle<MenuProps, any>({
  componentDidUpdate() {
    if (this.props.isOpen) {
      disableBodyScroll(document.getElementById(menuSectionsHtmlId));
    } else {
      enableBodyScroll(document.getElementById(menuSectionsHtmlId));
    }
  },
  componentWillUnmount() {
    clearAllBodyScrollLocks();
  },
})(Menu);



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/components/HeaderMenu/HeaderMenu.tsx